export class FilestorageConstants {
    static fileStorageProviders = [
        {
            displayName: 'S3 Bucket',
            image: './assets/img/partnerOnboarding/s3.jpeg',
            value: 's3',
            provider: 'apiplatform',
            selected: true,
            disabled: false,
            description: 'Amazon S3 bucket is a highly scalable and secure cloud storage service for storing and retrieving any amount of data from anywhere on the web.'
        }
    ];
}
